module.exports = __webpack_public_path__ + "media/36.7bdca735.mp3";